import { AfterViewInit, Component, computed, ElementRef, inject, Injector, output, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { AddressData, CommonAddressField, CommonAddressFieldConfig, CommonAddressFieldWidget, CommonButtonRowWidget, CommonForm } from '@eforall/common';
import { FuncService } from '../../../../../services';

@Component({
	selector: 'venue-add-part',
	standalone: true,
	imports: [
		CommonAddressFieldWidget,
		CommonButtonRowWidget
	],
	templateUrl: './venue-add.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./venue-add.part.scss']
})
export class VenueAddPart implements AfterViewInit {

	private func = inject(FuncService);
	public addressSelected = output<AddressData>();

	public addressFound = signal<AddressData | undefined>(undefined);
	public readonly form = new CommonForm<{ address: AddressData }>(inject(Injector));
	public venueFormAddBtn = viewChild.required<ElementRef<HTMLButtonElement>>('venueFormAddBtn');


	public readonly address = computed<CommonAddressField>(() => ({
		config: signal<CommonAddressFieldConfig>({
			label: 'Address',
			isRequired: true,
			funcGetCountyFipsId: this.func.address.getCountyFipsId,
		}),
		formFieldName: 'address',
		form: this.form,
		actualValue: computed(() => undefined),
		pendingValue: signal<AddressData | undefined | null>(null),
		saving: signal(false),
		error: signal(''),
	}));


	ngAfterViewInit() {
		this.form.setSubmitButton(
			this.venueFormAddBtn(),
			async (values: { address: AddressData }, changed: string[]) => {
				this.addressSelected.emit(values.address);
			}
		);
	}

}